/* eslint-disable no-undef */
import {
  GA_EVENT_CLOSE_DOWNLOAD_BANNER,
  GA_EVENT_DOWNLOAD_APP,
  GA_EVENT_OPEN_DOWNLOAD_BANNER,
  GA_EVENT_TYPE_FAQ,
  GA_EVENT_BACK_TO_HOME_PAGE_ERROR,
  GA_EVENT_BACK_TO_HOME_PAGE_EXPIRED,
} from '../../constants/google-analytics';

/**
 * This pushes events to the dataLayer.
 *
 * Note: This is not the place for documentation on how Google Tags work but just know
 * that you cannot simply add a new tag type here in the code without doing some pretty
 * substantial wiring on the GA/GTM side of things (ie, just because the debugger shows
 * your data is in the dataLayer doesn't mean its being tracked).
 *
 * tldr; If you pass a new event type you must first set it up (triggers, vars, etc)
 * in the GTM/GA UI.
 *
 * @param {*} event
 * @param {*} faqData
 */
const sendGAEvent = data => {
  if (dataLayer) {
    dataLayer.push(data);
  }
};
/* eslint-enable no-undef */
export const sendGAErrorBackError = () => {
  sendGAEvent({
    event: GA_EVENT_BACK_TO_HOME_PAGE_ERROR,
  });
};
export const sendGAErrorBackExpired = () => {
  sendGAEvent({
    event: GA_EVENT_BACK_TO_HOME_PAGE_EXPIRED,
  });
};
export const sendGAFaqEvent = faqData => {
  sendGAEvent({
    event: GA_EVENT_TYPE_FAQ,
    faqData,
  });
};

export const sendGADownloadAppEvent = () => {
  sendGAEvent({
    event: GA_EVENT_DOWNLOAD_APP,
  });
};

export const sendGAOpenDownloadBannerEvent = () => {
  sendGAEvent({
    event: GA_EVENT_OPEN_DOWNLOAD_BANNER,
  });
};

export const sendGACloseDownloadBannerEvent = () => {
  sendGAEvent({
    event: GA_EVENT_CLOSE_DOWNLOAD_BANNER,
  });
};
/**
 * GA is wired up for DL_FAQ_EVENT to accept anything in the second argument => so can
 * add/remove as many properties as you want to this return object << as long as> > you
 * return a single object.
 *
 * Note: Values will be converted to strings so use JSON.stringify()
 * when passing arrays or objects.
 *
 * @param {Object} currentStatusEvent   Object with shape of
 *                                      { event: 'SOME_EVENT' time:123456789' }
 * @param {String} title                Title of FAQ question used to track behavoir
 * @param {String} orderID
 * @param {String} orderType
 * @param {String} senderID
 */
export const FaqClickEventDataCreator = (
  currentStatusEvent = 'empty',
  title = 'empty',
  orderID = 'empty',
  orderType = 'empty',
  senderID = 'empty',
) =>
  JSON.stringify({
    title,
    currentStatusEvent,
    orderID,
    orderType,
    senderID,
  });
